import Home from './pages/home'
import Product from './pages/product'
import Browse from './pages/browse'
import Page from './pages/page'
import TestProducts from './pages/test-products'


export const routes = [
  { path: '/', component: Home, name: 'home' },
  { path: '/products', component: Browse, name: 'browse'},
  { path: '/products/:id', component: Product, name: 'product', props: true },
  { path: '/page/:slug', component: Page, name: 'page', props: true },
  { path: '/test-products', component: TestProducts, name: 'test-products' },
]